<template>
  <div>
    <Header ref="header" />
    <img :class="s.aboutBanner" :src="require('./images/aboutBg.jpg')" />
    <Content />
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Content from "./components/Content.vue";
import Footer from "./components/Footer.vue";
export default {
  components: {
    Header,
    Footer,
    Content,
  },
  computed: {
    s() {
      return this.$style;
    },
  },
  data() {
    return {};
  },
  mounted() {
    // console.log(this.$refs["header"]);
    this.$refs["header"].selected = 1;
  },
};
</script>

<style scoped lang="less" module>
.aboutBanner {
  display: block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue